export default {
    "label.update_translations_unsuccessful": "{count} éléments ont échoué :",
    "global.no_records": "Aucun historique",
    "notifications.rp_has_been_updated": "Votre projet Or a été mis à jour",
    "moduleTitle.files": "Fichiers",
    "label.coordinator": "Coordonnateur",
    "sidebar.translations_managment": "Gestion des traductions",
    "table.file": "Fichier",
    "label.report_overview": "Aperçu",
    "label.parent_agreement": "Consentement des parents",
    "parentalConsent.i_consent_to_and_understand_that": "6. Je comprends que des photos du participant pourraient être prises lors de certaines activités liées au prix et utilisées à des fins promotionnelles si le participant et un parent ou tuteur légal ont signé le formulaire de consentement approprié.",
    "parentalConsent.i_understand_that_participants_are_required_to_comply": "12. Je comprends que les participants sont tenus de respecter les exigences du Carnet du participant (papier ou virtuel), les plus récentes politiques et normes de conduite de l’entité responsable du Prix et les exigences du centre du Prix concernant les plans d’urgence, l’évaluation des activités et la tenue des voyages d’aventure liés au Prix, et que le centre du Prix peut exclure du Prix les participants qui ne respectent pas ces règles.",
    "table.end_date": "Date de fin",
    "label.activation_date": "Date d'activation",
    "label.report": "Rapport",
    "label.award_is_offline": "Le Prix est hors ligne",
    "label.pending_changes": "Changements en attente",
    "errors.min_nights_required": "Un minimum de {nights} nuit(s) est requis",
    "label.country": "Pays",
    "notifications.award_leader_has_been_returned": "Le chef de groupe a été révisé",
    "notifications.participant_has_been_updated": "Le participant a été mis à jour",
    "label.phone_number": "Numéro de téléphone",
    "roles.aj_assessor": "Évaluateur voyage d'aventure",
    "notifications.person_state_has_been_changed": "Le statut de la personne a été modifié",
    "pageTitle.dashboard": "Tableau de bord",
    "moduleTitle.global_payment_method": "Méthode de paiement global",
    "label.organization_type": "Type d'organisation",
    "button.account_settings": "Réglages du compte",
    "notifications.contact_has_been_updated": "Le contact a été mis à jour",
    "participant.recover_password": "Récupérer mon mot de passe",
    "notifications.assessment_request_has_been_sent": "La demande d'évaluation a été soumise",
    "button.unassign": "Désassigner",
    "label.start_date": "Date de début",
    "label.assign_labels": "Attribuer une étiquette",
    "sidebar.participants": "Participants",
    "roles.coordinator": "Coordonnateur",
    "label.organization_contact": "Contact de l'organisation",
    "tabs.customization": "Personnalisation",
    "sidebar.award_units": "Centres du Prix",
    "button.change_goal": "Modifier l'objectif",
    "translationsManagement.selectProject": "Sélectionner le projet",
    "award.rp": "Projet Or",
    "label.size": "Taille",
    "label.bulk_action_results": "Résultats des modifications de masse",
    "notifications.activity_has_been_approved": "L'activité a été approuvée",
    "label.payment_type": "Type de paiement",
    "button.gop_assignment": "Affectation POG",
    "button.resend_assessment_request": "Renvoyer la demande d'évaluation",
    "notifications.template_has_been_removed": "Le modèle a été enlevé",
    "button.award_settings": "Paramètres du Prix",
    "pageTitle.payment": "Paiement",
    "tasks.return_award": "Prix révisé",
    "label.link": "lien",
    "moduleTitle.award_participant_delete": "Supprimer le prix du participant",
    "pageTitle.mro_related_contacts": "Mon bureau régional - Contacts associés",
    "pageTitle.my_organization_labels": "Mon organisation- Étiquettes",
    "tabs.activity_signoff": "Validation du volet",
    "table.logs": "Entrées",
    "moduleTitle.remove_file": "Supprimer le fichier?",
    "label.email_confirmed": "Courriel confirmé",
    "notifications.activity_has_been_returned": "L'activité a été révisée",
    "label.note": "Note",
    "button.show": "Afficher",
    "tabs.adventurous_journey": "Voyage d'aventure",
    "sidebar.my_todolist": "Ma liste des choses à faire",
    "label.here": "ici",
    "organisation.change_award_mode": "Modifier le mode du Prix",
    "table.note_from_al": "Commentaires du chef de groupe",
    "label.gender": "Sexe",
    "moduleTitle.remove": "Enlever?",
    "errors.must_be_less_than": "Doit être moins de {limit}",
    "button.logout": "Déconnecter",
    "label.no_selected_participants": "Aucun participant sélectionné",
    "button.new_aj_event": "Nouvel évènement du voyage d'aventure",
    "label.employement_status": "Situation d'emploi",
    "tabs.logs": "Entrées",
    "tabs.contacts": "Contacts",
    "label.option": "Option",
    "dashboard.charts": "Tableaux",
    "notifications.rp_has_been_approved": "Votre projet Or a été approuvé",
    "pageTitle.new_participant": "Nouveau participant",
    "notifications.award_leader_has_been_approved": "Le chef de groupe a été approuvé",
    "moduleTitle.would_you_like_to_remove_leader_training": "Voulez-vous supprimer cette formation pour les chefs de groupe?",
    "moduleTitle.update_configuration_value": "Mettre à jour la configuration",
    "table.description": "Description",
    "table.organization": "Organisation",
    "label.youtube": "Youtube",
    "label.author": "Auteur",
    "table.suitable_for_award_level": "Approprié pour le niveau",
    "label.content_update": "Veuillez patientez. Mise à jour du contenu...",
    "notifications.new_question_has_been_added": "Votre nouvelle question a été ajoutée",
    "pageTitle.nao_awards": "Prix - Bureau national",
    "table.last_name": "Nom de famille",
    "moduleTitle.adventurous_journey_detail": "Détails du voyage d'aventure",
    "Description of the combo box selection in bulk operation panel": {"label.bulk_operations": "Modification de masse"},
    "label.project_location_type": "Type d'endroit pour le projet",
    "label.email_help_award_level": "Niveau du Prix.",
    "label.date": "Date",
    "label.previous_completed_award_place": "Où",
    "button.show_more": "Voir plus",
    "label.wwc_number": "numéro de WWC",
    "button.filter": "Filtrer",
    "notifications.rp_has_been_returned": "Le projet Or a été révisé",
    "pageTitle.residetial_project_assessor_report": "Projet Or - Rapport de l'évaluateur",
    "label.generating": "Création...",
    "moduleTitle.finance_system_data": "Données du système financier",
    "notifications.adventurous_journey_state_has_been_changed": "L'état de votre voyage d'aventure a été modifié",
    "route.levels": "Niveaux",
    "moduleTitle.activity_leader": "Activité du chef de groupe",
    "tasks.approve_event": "Évènement approuvé",
    "tasks.reject_event": "Évènement révisé",
    "table.region": "Région",
    "pageTitle.nao_award_leaders": "Chefs de groupe - Bureau national",
    "errors.must_be_at_least": "Doit contenir au minimum {min} caractères",
    "table.title": "Titre",
    "table.last_activity": "Dernière activité",
    "tasks.delete_registration": "Supprimer l'adhésion",
    "table.date_time": "Date / Heure",
    "parentalConsent.the_award_operators_are_committed_to_respecting": "14. Les entités responsables de l’administration du Prix respectent votre vie privée. Les renseignements personnels recueillis dans le présent formulaire le sont dans le seul but d’autoriser votre participation au Prix. Les participants doivent fournir ces renseignements, faute de quoi leur candidature ne sera pas considérée (cette condition ne s’applique pas aux renseignements du participant). Nous pourrions aussi utiliser vos renseignements personnels pour vous envoyer de l’information sur les autres activités ou événements du Prix qui pourraient vous intéresser. Nous nous réservons le droit de communiquer vos renseignements aux organisations et aux fournisseurs de services locaux et internationaux qui nous épaulent dans la tenue et l’administration du Prix. Pour nous joindre ou accéder à votre dossier, communiquez avec l’entité responsable du Prix de votre région. Vous pouvez aussi lui demander une copie de sa politique de confidentialité.",
    "aj.practice_journey": "Voyage préparatoire",
    "notification.log_has_been_restored": "L'entrée de l'activité a été restaurée.",
    "tabs.my_participants": "Mes participants",
    "label.bulk_action_assign_label": "Attribuer une étiquette",
    "moduleTitle.supervisor": "Superviseur",
    "moduleTitle.your_parental_consent": "Consentement parental",
    "route.registration_participants": "Adhésion des participants",
    "placeholder.start_typing": "Commencer à écrire",
    "tasks.approve_award": "Prix approuvé",
    "route.registrations": "Adhésions",
    "button.add_activity": "Ajouter une activité",
    "notifications.aj_event_has_been_created": "Un évènement du voyage d'aventure a été créé",
    "states.supervisor_approval": "Approbation de l'évaluateur",
    "label.description": "Description",
    "button.leave_anyway": "Quitter quand même",
    "tabs.registrations": "Adhésion",
    "states.leader_signoff": "Autorisation pour la section",
    "moduleTitle.forbidden": "Interdit",
    "notifications.translations_has_been_updated.button": "La traduction a été chargée avec succès.",
    "pageTitle.nao_registration": "Adhésion - Bureau national",
    "pageTitle.mro_logs": "Mon bureau régional - Entrées",
    "meta.page_not_found": "Page introuvable",
    "label.bulk_action_unsuccessful": "{count} items n'ont pas été modifiés:",
    "global.days": "jours",
    "table.review": "Réviser",
    "table.as_assessor_for": "Évaluateur de",
    "roles.if_staff_statistical_user": "Personnel de la Fondation utilisateur statistique",
    "table.levels": "Niveaux",
    "label.suitable_for_level": "Approprié pour le niveau",
    "pageTitle.leaders": "Chefs de groupe",
    "moduleTitle.send_test_email": "Envoyer un courir test",
    "pageTitle.tasks_removed_registration": "Adhésions du participant supprimés",
    "label.you_will_be_forced_to_login_again_after_change": "Vous devrez vous reconnecter après la modification.",
    "table.recent_updates": "Mises à jour récentes",
    "pageTitle.tasks_activity_signoffs": "Validation du volet",
    "pageTitle.payments": "Paiements",
    "global.nights": "nuits",
    "label.blank_any_level": "BLANC à tous les niveaux",
    "button.view_section": "Voir le volet",
    "moduleTitle.select_organization": "Sélectionner une organisation",
    "pageTitle.manual_data_import": "Importation manuelle des données",
    "button.upload_files": "Téléverser des fichiers",
    "label.migrated_contact_email": "Courriel transféré",
    "label.for_award_unit": "Pour le centre du Prix",
    "label.aj_template_note": "Note sur le modèle",
    "table.last_log_added": "Dernière entrée",
    "button.view_participant": "Commentaires du participant",
    "label.please_comment_on_the_participants": "Veuillez commentez l'amélioration, la performance ou l'implication du participant.",
    "label.consent_already_given_login": "Le consentement a déjà été donné. Connectez-vous en tant que votre enfant.",
    "participant.level_start_date": "{value} date de début",
    "sidebar.my_region_office": "Mon bureau divisionnaire",
    "states.section_signoff": "Validation du volet",
    "moduleTitle.assessor_details": "Détails de l'évaluateur",
    "moduleTitle.adventurous_journey_settings": "Réglages du voyage d'aventure",
    "moduleTitle.note_from_al": "Commentaires du chef de groupe",
    "button.add_role": "Ajouter un rôle",
    "table.run": "Débuter",
    "states.change_to_state_warning_missing_assessment": "AVERTISSEMENT : L'évaluation n'a pas été téléversé. Voulez-vous continuer?",
    "label.user_app_guide_leader": "Guide de l'utilisateur pour l'application - Chef de groupe",
    "tabs.section_approval": "Approbation du volet",
    "roles.award_verifier": "Vérificateur du prix",
    "tabs.activity_approval": "Approbation de l'activité",
    "logs.add_log": "Ajouter une entrée",
    "tabs.award": "Prix",
    "notifications.this_role_has_read_only_persmission": "Votre rôle vous permet seulement une lecture",
    "table.no_filtered_results": "Aucun résultat",
    "button.praise": "Commentaire",
    "label.prevent_welcome_email_assessor": "Ne pas envoyer d'email de bienvenue à l'évaluateur",
    "label.location_detail": "Détails de l'endroit",
    "label.optional": "(optionnel)",
    "errors.do_not_match": "Ne correspond pas",
    "label.use_comma_for_multiple_entries": "Utiliser la virgule pour les entrées multiples.",
    "label.operating_authority": "Entité d'opération",
    "label.activity_section": "Volet d'activité",
    "notifications.you_have_been_logged_out": "Vous êtes déconnectés",
    "table.finished": "Terminé",
    "button.same_as_billing": "Même que la facturation",
    "table.payment": "Paiement",
    "table.current_level": "Niveau en cours",
    "button.view_nao": "Commentaire du bureau du Prix",
    "table.email_confirmation": "Courriel de confirmation",
    "moduleTitle.shipping_address": "Adresse d'envoi",
    "label.secondary_phone_type": "Type de numéro de téléphone secondaire",
    "notifications.saved": "Sauvegardé",
    "pageTitle.all_participants": "Tous les participants",
    "label.first_name": "Prénom",
    "label.oa_price": "Coût de l'entité responsable du Prix",
    "table.award_mode": "Mode du Prix",
    "tabs.api_keys": "Clés API",
    "award.award_detail": "Détail du Prix",
    "tabs.user_management": "Gestion des utilisateurs",
    "tabs.all_events": "Tous les évènements",
    "notifications.history_record_has_been_removed": "L'historique a été supprimé",
    "award.no_data": "Aucunes informations",
    "notifications.preparation_training_has_been_added": "L'entraînement préparatoire a  été ajouté",
    "label.message": "Message",
    "notifications.participant_info_updated": "Les informations du participant a été mise à jour",
    "roles.nao_staff": "Personnel de l'entité national",
    "tabs.adventurous_journeys": "Voyage d'aventure",
    "label.gops": "Partenaires opérationnels mondiaux",
    "route.upload": "Téléverser",
    "notifications.history_record_has_been_added": "L'historique a été ajouté",
    "notifications.history_record_has_been_updated": "L'historique a été mis à jour",
    "label.no_data": "Aucunes données",
    "button.add_coordinator": "Ajouter un coordonnateur",
    "label.you_are_already_logged_as": "Vous êtes connectés en tant que",
    "route.my_national_office": "Mon bureau national",
    "tabs.leaders": "Chefs de groupe",
    "label.email_confirmation": "Courriel de confirmation",
    "table.registration_date": "Date d'adhésion",
    "notifications.role_has_been_removed": "Votre rôle a été supprimé ",
    "button.move": "Déplacer",
    "label.terms_and_conditions": "Termes et conditions",
    "pageTitle.detail": "Détail",
    "table.award_unit": "Centre du Prix",
    "sidebar.settings": "Réglages",
    "dashboard.leader_state": "Chefs de groupe par province",
    "notifications.award_unit_has_been_approved": "Le centre du Prix a été approuvé",
    "states.awaiting_approval": "En attente d’approbation",
    "table.level": "Niveau",
    "table.action_requested": "Action démandée",
    "label.organisation_mode": "Mode de l'organisation",
    "label.no_note": "Aucune note",
    "tabs.my_events": "Mes évènements",
    "notifications.participants_have_been_added": "Les participants ont été ajoutés",
    "tabs.registration_questions": "Questions",
    "button.delete_registration": "Supprimer l'adhésion",
    "notifications.parental_consent_link_has_been_sent": "Le lien du consentement parental a été envoyé.",
    "moduleTitle.select_role_organization": "Sélectionner votre rôle et organisation",
    "label.experience": "Expériences",
    "translationsManagement.modal.title": "Voulez-vous mettre à jour la traduction?",
    "table.ic": "Conseil international",
    "table.id": "Identification",
    "label.notify_email_explanation": "Le participant recevra un courriel pour l'informer que sa demande d'évaluation n'a pas été remis à son évaluateur. Il devra modifier le courriel et soumettre la demande à nouveau.",
    "participant.would_you_like_to_remove": "Voulez-vous supprimer ce compte?",
    "table.fields_included": "Champs inclus",
    "label.user_guide_web_leader": "Guide de l'utilisateur Web - Chef de groupe",
    "label.journey_type": "Type de voyage",
    "button.setup": "Configuration",
    "tabs.my_national_office": "Mon bureau national",
    "notifications.training_has_been_removed": "Une formation a été retirée.",
    "label.nominated_and_identified_persons": "Personnes autorisées à consulter toutes les données, mais pas à les modifier.",
    "moduleTitle.you_have_been_logged_out_due_to_inactivity": "Vous avez été déconnecté puisque vous étiez inactif.",
    "states.award_leader_signoff": "Validation par le chef de groupe",
    "table.award_signoff_attempts": "Tentatives d'approbation du Prix",
    "sidebar.regions": "Régions",
    "label.activity_deleted_note": "L'activité a été supprimé. Vous pouvez la restaurer en cliquez sur le button ci-dessous",
    "table.total": "Total",
    "errors.a_problem_has_occured_during_processing": "Un problème est survenu, obtenez plus d'information",
    "participant.participant_already_has_gold_award": "Le participant a déjà complété le prix Or",
    "pageTitle.mro": "Mon bureau divisionnaire",
    "notifications.authorization_code_has_expired": "Le code d'autorisation est expiré.",
    "moduleTitle.child_organization_labels": "Étiquettes d'organisation pour enfants",
    "aj.aj_events": "Évènement du voyage d'aventure",
    "global.loading": "Chargement",
    "label.gnipp": "GNIPP",
    "sidebar.registrations": "Adhésions",
    "label.any_string": "Toute chaîne",
    "contact.change_contact_status": "Modifier le statut du contact",
    "tabs.registration": "Adhésion",
    "label.override_payment_note": "Remplacer la note de paiement",
    "notifications.section_has_been_signed_off": "Le volet a été validé",
    "label.payment_date": "Date du paiement",
    "button.approve": "Approuver",
    "moduleTitle.loggin_in": "Connexion",
    "label.website": "Site Web",
    "label.role": "Rôle",
    "table.assessor_report": "Rapport de l'évaluateur",
    "label.ue_fe": "Interface d'engagement de l'utilisateur (étiquettes statiques web du participant)",
    "label.please_comment_on_the_participants_effort": "Veuillez commenter la façon dont le participant a fait preuve d'efforts pour atteindre l'objectif de l'activité.",
    "label.previously_worked_as_assessor": "A déjà été un évaluateur",
    "pageTitle.registrations": "Adhésions",
    "parentalConsent.this_form_must_be_completed": "Le présent formulaire <strong>doit être</strong>  rempli par le parent ou tuteur légal des participants de moins de <strong> 18 ans ou mineurs dans leur pays de résidence </strong>.",
    "button.apply": "Appliquer",
    "errors.include_at_least_one_number": "Doit contenir au moins un chiffre",
    "label.content_restore": "Rafraîchir la session...",
    "logs.hour": "heure",
    "parentalConsent.i_have_read_and_understand": "7. J’ai lu et compris le fonctionnement et les exigences des différents niveaux du Prix, présentés dans le résumé du Prix à la page 5 de ce formulaire.",
    "notifications.award_was_deleted": "Le Prix a été supprimé.",
    "label.journey_category": "Catégorie de voyage",
    "notifications.search_cancelled": "La recherche a été interrompue. Vous devez attendre la fin de la recherche.",
    "route.detail": "Détails",
    "route.user_guide": "Guide d'utilisateur",
    "moduleTitle.history": "Historique",
    "table.gop_name": "Partenaire opérationnel mondial",
    "pageTitle.tasks_unassigned_participants": "Participants sans chef de groupe",
    "states.inactive": "Inactif",
    "pageTitle.search_results": "Résultats de la recherche",
    "button.proceed_to_login": "Procédez à la connexion",
    "pageTitle.assessor_report_reject": "Rapport de l'évaluateur révisé",
    "notifications.contact_has_been_removed": "Le contact a été supprimé",
    "sidebar.operating_authorities": "Entité d'opération",
    "label.no_note_from_participant": "Aucun commentaire du participant",
    "aj.preparation_and_training": "Entraînement préparatoire",
    "route.user_guide_web_leader": "Guide de l'utilisateur Web - Chef de groupe",
    "label.position_in_organization": "Rôle dans l'organisation",
    "errors.emails_dont_match": "Les courriels ne correspondent pas",
    "route.my_participants": "Mes participants",
    "pageTitle.customisations": "Personnalisation",
    "tabs.localization_files": "Fichiers de localisation",
    "table.assessor_approval": "Approbation de l'évalutateur",
    "tabs.related_contacts": "Contacts associés",
    "table.aus": "Centres du Prix",
    "table.category": "Catégorie",
    "errors.file_is_too_large": "La taille maximale du téléchargement est de 20MB",
    "label.possible_values": "Valeurs possibles:",
    "label.if_your_download_doesnt_start": "Si votre téléchargement ne débute pas automatiquement, cliquez ici",
    "route.independent_award_centres": "Centres public du Prix",
    "pageTitle.user_guide": "Guide d'utilisateur",
    "button.visit": "Visite",
    "label.hours_first_letter": "h",
    "pageTitle.my_organization_detail": "Mon organisation - Détail",
    "pageTitle.nao_detail": "Informations - Bureau national",
    "button.change": "Changer",
    "award.aj": "Voyage d'aventure",
    "table.award_state": "Statut du Prix",
    "pageTitle.tasks_award_signoff": "Validation du bureau",
    "pageTitle.regions": "Régions",
    "notifications.award_has_been_signed_off": "Le prix a été validé",
    "dashboard.award_approved_by": "Prix approuvés par niveau en 2016",
    "tabs.new_template": "Nouveau modèle",
    "error.parent_email_must_be_filled": "Le courriel du parent doit être entré",
    "label.organisation_invoicing_name": "Nom de l'organisation facturée",
    "pageTitle.related_contacts": "Contacts associés",
    "button.try_again": "Fermer la fenêtre d'avertissement et réessayer",
    "label.cannot_be_change_to_another": "Ne peut pas être transféré à un autre niveau",
    "notifications.lead_coordinator_has_been_set": "Un nouveau coordonnateur a été désigné",
    "label.training_name": "Nom de la formation",
    "moduleTitle.new_contact": "Nouveau contact",
    "translationsManagement.modal.updateTitle": "Êtes-vous sûre?",
    "moduleTitle.offline_award_units_signoff": "Approbation du chef de groupe hors ligne",
    "notifications.award_level_has_been_changed": "Votre niveau du Prix a été changé",
    "label.subject": "Sujet",
    "route.silver_level": "Prix argent",
    "label.privacy_notice": "Avis de confidentialité",
    "label.switch_organization": "Transférer de groupe",
    "meta.dofe_name": "Le Prix du Duc d'Édimbourg",
    "route.profile": "Profil",
    "roles.super_user": "Superutilisateur",
    "dashboard.while_you_were_gone": "Pendant votre absence",
    "label.no_note_from_award_leader": "Aucun commentaire du centre du Prix",
    "label.middle_name": "Second prénom",
    "moduleTitle.new_activity": "Nouvelle activité",
    "organisation.would_you_like_to_remove": "Voulez-vous supprimer cette organisation?",
    "label.state_province": "État/Province/Région",
    "moduleTitle.your_home_address": "Adresse de résidence",
    "tabs.sign_offs": "Approbations",
    "moduleTitle.logs": "Entrées",
    "button.view_more": "Voir plus",
    "label.profile": "Profil",
    "label.title": "Titre",
    "tabs.award_signoff": "Validation du Prix",
    "label.post_code": "Code postal",
    "states.ceremony_certificate": "Cérémonie et certificat",
    "label.code": "Code",
    "parentalConsent.i_consent_to_the_provision_of_any": "13. Je consens à ce que les renseignements personnels que j’ai fournis (y compris les renseignements du participant) soient transmis au centre du Prix et à l’entité responsable du Prix. Je consens à ce que ces renseignements soient traités conformément à la plus récente version de la politique de confidentialité de l’entité responsable du Prix, aux principes nationaux de protection de la vie privée énoncés dans la Data Protection Act de 1998 du Royaume-Uni (ou dans toute politique ou loi équivalente sur le territoire où a lieu le Prix) et à toute autre loi, norme, directive ou instruction à laquelle ces renseignements sont assujettis en vertu des lois sur la protection de la vie privée.",
    "label.user_guide_web_participant": "Guide de l'utilisateur Web - Participant",
    "label.award_unit_type": "Type de centre du Prix",
    "states.complete": "Complet",
    "table.participant_state": "Statut du participant",
    "pageTitle.my_organization_payment": "Mon organisation - Paiement",
    "table.approved": "Approuvé",
    "pageTitle.my_organization_contacts": "Mon organisation - Contacts",
    "warning.award_marked_as_paid_registration": "Attention :L'inscription à ce Prix est marquée comme payée.   Veuillez consulter les directives de paiement et de remboursement avant de confirmer.",
    "states.change_to_state": "Modifier l'état pour <strong>{state}</strong>",
    "label.integer": "Entier",
    "notifications.translationUpdateInterrupted": "La mise à jour a été interrompue",
    "notifications.password_has_been_changed": "Le mot de passe a été modifié",
    "button.invite_assessor": "Inviter l'évaluateur",
    "label.other_activity": "Autre activité",
    "notifications.parental_consent_has_been_sent": "Le consentement parental a été envoyé",
    "button.revise": "Réviser",
    "errors.end_date_must_be_after_start_date": "La date de fin doit être après la date de début",
    "label.award_leader_signoff_date": "Date d'approbation du chef de groupe",
    "parentalConsent.i_understand_every_participant_must": "8. Je comprends qu’il faut faire partie d’un centre du Prix pour participer au Prix et que les centres du Prix peuvent accepter ou refuser les participants et les activités qu’ils aimeraient réaliser dans le cadre du Prix.",
    "moduleTitle.policies": "Politiques",
    "pageTitle.tasks_aj": "Voyage d'aventure",
    "global.day": "jour",
    "moduleTitle.coordinator": "Coordonnateur",
    "label.region": "Région",
    "button.add_history_record": "Ajouter l'historique",
    "moduleTitle.adventurous_journey_template_settings": "Réglages des modèles du voyage d'aventure",
    "notifications.personal_details_have_been_updated": "Vos informations personnelles ont été mis à jour",
    "sidebar.ics": "Conseil international",
    "table.independent_award_centre": "Centre public du Prix",
    "label.undelivered_mail_reason": "Raison pour courriel non remis",
    "table.utc_date_time": "Temps UTC",
    "moduleTitle.emails": "Courriels",
    "label.backoffice": "Backoffice",
    "moduleTitle.parent_consent": "Consentement des parents / tuteurs",
    "label.photo_consent_given": "Le participant accepte que sa photo de profil soit utilisée pour la promotion",
    "moduleTitle.authorising_contact": "Contact autorisé",
    "label.assessment_with_role": "Évaluation de {role}",
    "dashboard.type_of_awards": "Type de centre du Prix",
    "moduleTitle.payment": "Paiement",
    "states.in_progress": "En cours",
    "logs.no_logs": "Aucune entrée",
    "sidebar.my_office": "Mon bureau",
    "label.assessor_report": "Rapport de l'évaluateur",
    "notifications.rp_has_been_signed_off": "Le projet Or a été validé",
    "tabs.labels": "Étiquettes",
    "sidebar.payments": "Paiements",
    "meta.profile_questions": "Questions du profil",
    "label.fax": "Télécopieur",
    "label.email_help_custom_link": "Lien personnalisable, si activé.",
    "label.last_name": "Nom de famille",
    "organisation.manage_gop": "Partenaires opérationnels mondiaux",
    "table.parental_consent": "Consentement parental",
    "dashboard.participant_by_level": "Participants par niveau",
    "tabs.award_leaders": "Chefs de groupe",
    "label.i_confirm_that_ive_witnessed": "Je confirme avoir été témoin des activités incluses dans le carnet du participant",
    "table.lead_coordinator": "Coordonnateur principal",
    "states.deleted": "Supprimé",
    "label.no_answers": "Aucune réponse",
    "button.add": "Ajouter",
    "label.exchequer_number": "numéro Exchequer",
    "label.waiting": "En attente",
    "label.email_help_person_full_name": "Nom complet de la personne.",
    "tasks.return_registration": "Inscription révisée",
    "notifications.state_aj_preparation_training_has_been_changed": "Le statut de l'entraînement préliminaire du voyage d'aventure a été changé.",
    "label.parent_approval": "Consentement des parents",
    "table.assessor_approve": "Approbation de l’évaluateur",
    "errors.some_fields_requires_your_attention": "Certains champs requièrent votre attention",
    "aj.qualifying_journey": "Voyage de qualification",
    "route.awards": "Prix",
    "table.registration": "Adhésion",
    "pageTitle.assessors": "Évaluateurs",
    "notifications.award_has_been_updated": "Votre Prix a été mis à jour",
    "errors.must_be_one_of": "Doit figurer parmi les suivants :{enums}",
    "pageTitle.logs": "Entrées",
    "notifications.notifications.invitation_has_been_sent": "L'invitation a été envoyée.",
    "route.national_offices": "Bureaux nationaux",
    "notifications.training_has_been_updated": "Une formation a été mise à jour.",
    "label.parent_last_name": "Nom de famille du parent / tuteur",
    "table.leaders": "Chefs de groupe",
    "states.award_level_complete": "Niveau complété",
    "button.reset": "Réinitialiser",
    "sidebar.my_award_unit": "Mon centre du Prix",
    "pageTitle.all_aj_events": "Tous les évènements du voyage d'aventure",
    "label.activity": "Activité",
    "moduleTitle.are_you_sure": "Êtes-vous sûr?",
    "route.gold_level": "Prix Or",
    "table.evidence": "Pièces justificatives ",
    "label.delivery_confirmed": "Livraison confirmée",
    "parentalConsent.as_the_parent": "En tant que parent ou tuteur légal du participant, j’autorise la Fondation à utiliser toutes images à des fins promotionnelles.",
    "label.awardMode.offline": "Hors ligne",
    "tasks.approve_registration": "Approuver l'adhésion",
    "note.change_the_email_will_change": "Note: Changer le courriel va aussi modifier le courriel du contact transféré",
    "notifications.participant_has_been_approved": "Le participant a été approuvé",
    "label.reached_activity_limit": "Le nombre maximal d'activité permises est atteint. Un participant peut effectuer un maximum de 3 activités différentes pour un volet.",
    "label.facebook": "Facebook",
    "notifications.label_has_been_removed": "L'étiquette a été mise à jour",
    "label.action_required": "Action requise Action requise",
    "notifications.preparation_training_has_been_removed": "L'entraînement préparatoire a été supprimé",
    "pageTitle.settings": "Réglages",
    "participant.level_registration_date": "Date d'adhésion {value}",
    "notifications.question_has_been_removed": "La question a été supprimée",
    "label.email_help_award_leader_full_name": "Nom complet du chef de groupe.",
    "sidebar.leaders": "Chefs de groupe",
    "notifications.participants_have_been_transferred": "Le participant a été transféré",
    "tabs.assessors": "Évaluateurs",
    "sidebar.dashboard": "Tableau de bord",
    "pageTitle.independent_award_centers": "Centre public du Prix",
    "label.search": "Recherche",
    "moduleTitle.office_labels": "Étiquettes de bureau",
    "label.note_from_participant": "Commentaires pour le participant",
    "errors.required_field": "Champs obligatoire",
    "tasks.approve_task": "Approuver la tâche",
    "logs.edit_log": "Modifier l'entrée",
    "table.state": "États",
    "moduleTitle.level_summary": "Sommaire du niveau",
    "moduleTitle.guides": "\nGuides",
    "modal.close": "Fermer",
    "label.parent_first_name": "Prénom du parent / tuteur",
    "parentalConsent.i_understand_that_the_participant": "1. Je comprends que le participant ne peut commencer le Prix tant qu’il n’a pas retourné à l’entité indiquée le présent formulaire dûment rempli avec la signature du parent ou tuteur légal et le paiement des frais d’inscription applicables, et tant qu’il n’a pas été accepté par le centre du Prix.",
    "tabs.award_units": "Centres du Prix",
    "table.hours": "heures",
    "label.type": "Type",
    "notifications.adventurous_journey_has_been_removed": "Le voyage d'aventure a été enlevé",
    "label.aj_is_not_approved_yet": "Voyage d'aventure non approuvé pour le moment",
    "roles.authorizing_contact": "Contact autorisé",
    "table.date_submitted_to_office_signoff": "Date de la soumission au bureau pour approbation",
    "notifications.section_has_been_returned": "Le volet a été révisé",
    "table.created_by": "Créé par",
    "route.user_guide_web_participant": "Guide de l'utilisateur Web - Participant",
    "route.templates": "Modèles",
    "states.awaiting_sign_off": "En attente de validation par le chef de groupe",
    "table.phone": "Téléphone",
    "label.parental_consent": "Consentement des parents",
    "label.org_contact_will_be_deleted": "Vous supprimez le dernier rôle de ce contact dans cette organisation. Voulez-vous conserver les informations personnelles en tant que contact lié ou voulez-vous supprimer complètement le contact de cette organisation ?",
    "route.bronze_level": "Prix bronze",
    "label.invoice_currency": "Devise de la facturation",
    "button.new_label": "Nouvelle étiquette",
    "error.server_cannot_be_reached_at_the_moment": "Il n'est pas possible de joindre le serveur pour le moment. Veuillez réessayer plus tard. Si le problème persiste, veuillez communiquer avec votre équipe de soutien.",
    "notifications.contact_has_been_created": "Le contact a été créé",
    "pageTitle.profile_questions": "Questions de profil",
    "table.observation_files": "Fichiers d'observations",
    "table.participants": "Participants",
    "tasks.no_evidence": "Aucune pièce justificative fourni",
    "button.edit": "Modifier",
    "moduleTitle.leader": "Chef de groupe",
    "notifications.new_template_has_been_updated": "Un nouveau modèle a été mis à jour",
    "table.name": "Nom",
    "label.no_results": "Aucun résultat",
    "moduleTitle.documents": "Documents",
    "button.invite": "Inviter",
    "label.goal": "Objectif",
    "pageTitle.nao_award_units": "Bureau national - centres du Prix",
    "label.award_delete_participant_id": "ID du participant",
    "errors.at_least_num_characters": "Doit contenir au moins {length} caractères",
    "label.email_help_note": "Note personnalisable, si activée.",
    "label.person_status.activating": "label.person_status.activating",
    "moduleTitle.remove_role": "Supprimer un rôle?",
    "label.total": "Total",
    "label.delete_participant_award_info": "Vous êtes sur le point d'effacer le niveau de prix. Ceci est irréversible. Règles :\na) Le participant doit avoir plus que des prix. \nb) l'activité majeure sera réinitialisée si elle était requise pour le niveau de prix que vous êtes sur le point de supprimer. \nc) s'il reste deux récompenses après la suppression, l'activité principale sera réinitialisée sur la récompense la plus basse, uniquement si elle n'est pas en état d'authentification, d'achèvement ou de cérémonie.",
    "route.leaders": "Chefs de groupe",
    "table.start_date": "Date de début",
    "moduleTitle.coordinators": "Coordonnateurs",
    "button.create": "Créer",
    "tabs.awards": "Prix",
    "parentalConsent.form_has_been_sent": "Le consentement parental a été soumis",
    "states.journey_approval": "Approbation du voyage d'aventure",
    "pageTitle.reports": "Rapports",
    "table.journey_type": "Type de voyage",
    "label.yes": "Oui",
    "pageTitle.assessor_report": "Rapport de l'évaluateurs",
    "label.organization": "Organisation",
    "notifications.award_leader_has_been_updated": "Le chef de groupe a été mis à jour",
    "moduleTitle.edit_role": "Modifier le rôle",
    "table.journey_activity": "Activité du voyage",
    "label.location": "Endroit",
    "label.update_translations_error_item": "La mise à jour de la traduction a échoué pour : {language}, code : {localeCode}, projet : {projectCode} car",
    "pageTitle.adventurous_journeys": "Voyages d'aventure",
    "global.assessor": "Évaluateur",
    "moduleTitle.profile_questions": "Questions sur le profil",
    "activity.cannot_edit_activity_if_award_in_state": "Impossible de modifier l'activité si le prix est {state}",
    "moduleTitle.assessor_detail": "Détails de l'évaluateur",
    "parentalConsent.i_understand_that_upon_acceptance_into": "10. Je comprends qu’une fois que le centre du Prix aura accepté son inscription au Prix, le participant recevra un Carnet du participant ou aura accès au Carnet virtuel du participant. Le participant devra lire les exigences énoncées dans le Carnet avant d’entamer toute activité liée au Prix. Je comprends qu’il revient au centre du Prix d’établir si les exigences du Prix ont été satisfaites et, par conséquent, si un prix Bronze, Argent ou Or doit être décerné au participant. Je comprends aussi que l’entité responsable du Prix peut fournir aux participants une assurance limitée couvrant les accidents personnels et la responsabilité civile à partir du moment où le centre du Prix accepte l’inscription du participant au Prix, mais qu’il revient au participant et à son parent ou tuteur légal de souscrire une assurance couvrant les accidents personnels.",
    "notifications.award_has_been_returned": "Le Prix a été révisé",
    "label.code_of_conduct": "Code de conduite",
    "button.new_contact": "Nouveau contact",
    "tabs.payments": "Paiements",
    "roles.naa_oa_staff": "Personnel de l'entité responsable du Prix",
    "label.switch_organisation_hint": "Vous pouvez ouvrir le dialogue à n'importe quel moment en cliquant sur changer d'organisation dans le coin supérieur droit du menu.",
    "label.expiration_date": "Date d'expiration",
    "tabs.participants": "Participants",
    "table.practice": "Pratique",
    "notifications.one_activity_has_to_remain": "Vous devez garder au moins une activité dans un volet",
    "label.qualifications": "Qualifications",
    "states.organization_approval": "Approbation de l'organisation",
    "errors.must_be_an_integer": "Doit être un nombre entier",
    "participant.send_confirmation_email_again_question": "Envoyer le courriel de confirmation à nouveau?",
    "button.dismiss": "Rejeter",
    "table.advice": "Avis",
    "label.years_of_working_experience": "Nombre d'années d'expérience au travail",
    "notifications.search_failed": "Une erreur s'est produite lors de la recherche. Veuillez réessayer plus tard.",
    "notifications.changes_have_been_saved": "Les modifications ont été sauvegardées.",
    "moduleTitle.resend_parental_consent_link": "Renvoyer le lien du consentement parental?",
    "label.activity_type": "Type d'activité",
    "label.change_award": "Changer de Prix",
    "label.email": "Courriel",
    "button.remove": "Enlever",
    "button.download": "Télécharger",
    "label.vat_treatment": "Traitement de la TVA",
    "pageTitle.aj_template_new": "Nouveau modèle pour le voyage d'aventure",
    "table.per_page": "par page",
    "notifications.translations_has_been_updated": "La traduction a été mise à jour",
    "notification.award_mode_has_been_updated": "Le mode du Prix a été mis à jour",
    "tasks.revise_item": "Élément révisé",
    "button.resend_parental_consent": "Renvoyer le consentement parental",
    "table.weeks_completed_required": "semaines complétées / requises",
    "label.last_modified": "Dernière modification",
    "table.major": "Concentration",
    "label.vat_number": "No. TVA",
    "errors.passwords_dont_match": "Les mots de passes ne correspondent pas",
    "table.country": "Pays",
    "sidebar.guides_and_policies": "Guides et politiques",
    "notifications.question_has_been_updated": "La question a été mise à jour",
    "table.participant_name": "Nom du participant",
    "label.registration_approval_date": "Date approbation de l'adhésion",
    "notifications.auth_code_is_no_longer_valid": "Le code d’autorisation est expiré.",
    "errors.must_be_no_more_than": "Peut contenir un maximum de {max} caractères",
    "notifications.event_has_been_rejected": "L'évènement a été révisé",
    "tabs.customizations": "Personnalisation",
    "label.name_organization": "Nom",
    "button.add_log": "Ajouter une entrée",
    "moduleTitle.invite_assessor": "Inviter l'évaluateur",
    "label.resend_confirmation_email": "Renvoyer le courriel de confirmation",
    "text.all_participants_will_be_transfered": "Tous les participants seront transférés au nouveau chef de groupe",
    "label.repeat_email": "Entrer à nouveau votre courriel",
    "errors.email_or_phone_required": "Courriel ou téléphone obligatoire",
    "notifications.role_has_been_updated": "Le rôle a été mis à jour",
    "roles.if_staff_stat_user": "Statistician de la Fondation",
    "participant.delete_account": "Supprimer ce compte",
    "moduleTitle.would_you_like_to_remove_this_log": "Voulez-vous supprimer cette entrée?",
    "sidebar.sgops": "SPOGs",
    "label.prepare_new_email": "Préparer un nouveau courriel",
    "table.journey_category": "Catégorie du voyage",
    "sidebar.manual_data_import": "Importation manuelle des données",
    "label.created_after_date": "Créé après",
    "route.my_organization": "Mon organisation",
    "button.show_list": "Afficher la liste",
    "label.leaders": "Chefs de groupe",
    "notifications.log_has_been_modified": "L'entrée a été modifiée",
    "button.upload_file": "Téléverser le fichier",
    "moduleTitle.which_section_do_you_want_to": "Quel volet voulez-vous remettre en cours?",
    "tabs.bronze_level": "Prix Bronze",
    "notifications.participants_have_been_saved": "Les participants ont été sauvegardés",
    "pageTitle.aj_template_detail": "Voyage d'aventure",
    "label.parent_email": "Courriel des parents / tuteurs",
    "map.appr_location": "Adresse approximative",
    "notifications.log_has_been_removed": "L'entrée a été supprimée",
    "notifications.label_has_been_assigned": "L'étiquette a été attribuée.",
    "pageTitle.tasks_undelivered_emails": "Courriels non remis",
    "button.stay": "Rester",
    "table.previous_level": "Niveau précédent",
    "label.award_start_date": "Date de début du Prix",
    "assessor_report.returned_to_participant": "Renvoyer au participant",
    "pageTitle.tasks_assessors_registration": "Adhésion de l'évaluateur",
    "aj.cannot_modify_award": "Vous ne pouvez changer le niveau de prix du participant si celui-ci a déjà un chef de groupe.",
    "moduleTitle.lost_internet_connection": "Il semblerait que vous ayez perdu votre connexion Internet",
    "states.ceremony": "Cérémonie",
    "participant.reactivate_account": "Réactiver le compte",
    "label.birthdate": "Date de naissance",
    "pageTitle.assessment_send_successfully": "Demande d'évaluation soumise avec succès",
    "states.assessor_approval": "Approbation de l'évaluateur",
    "award.change_award_level": "Changer le niveau du Prix",
    "label.url_no_longer_valid": "Cet URL n'est plus valide",
    "button.update": "Mettre à jour",
    "label.secondary_email": "Courriel secondaire",
    "button.role_edit": "Modifier",
    "table.award_leader": "Chef de groupe",
    "label.level": "Niveau",
    "tasks.evidence": "Pièces justificatives",
    "notifications.participant_is_already_in_list": "Le participant est déjà dans la liste",
    "button.clear": "Effacer",
    "label.allow_log_after_25_yoa": "Autoriser l'ajout de données après 25 ans.",
    "states.setup": "Configuration",
    "table.activity": "Activité",
    "label.copy_to_clipboard": "{text} a été copié dans le presse-papier",
    "route.award_units": "Centres du Prix",
    "button.upload_photo": "Téléverser la photo",
    "table.hours_completed_required": "Heures complétées / requises",
    "table.first_name": "Prénom",
    "notifications.adventurous_journey_has_been_returned": "Le voyage d'aventure a été révisé",
    "pageTitle.national_offices": "Bureaux nationaux",
    "notifications.you_have_been_logged_in": "Vous êtes connectés",
    "logs.offline": "Hors ligne",
    "moduleTitle.add_role": "Ajouter un rôle",
    "label.user_app_guide_participant": "Guide d'utilisateur pour l'application - Participant",
    "notifications.file_has_been_removed": "Le fichier a été supprimé",
    "label.send_message": "Envoyer le message",
    "button.select": "Sélectionner",
    "label.reason_of_deletion": "Raison pour la suppression",
    "label.user_guide": "Guide d'utilisateur",
    "pageTitle.nao_participants": "Participant - Bureau national",
    "tabs.sub_operating_partners": "Partenaires sous-opérationnels",
    "table.uploaded_by": "Téléversé par",
    "tasks.approve_item": "Approuver l'élément",
    "tasks.restore_participant_registration": "Restaurer l'adhésion du participant?",
    "label.awardMode.hybrid": "hybride",
    "table.first_activity_started": "Première activité commencée",
    "moduleTitle.dates": "Dates",
    "table.no_results": "Aucuns résultats",
    "states.registration_approval": "Approbation de l'adhésion",
    "table.breakdown_of_hours": "Détails des heures",
    "pageTitle.tasks_registration": "Adhésion du participant",
    "button.create_new": "Créer un nouvel élément",
    "sidebar.todolist": "Chose à faire",
    "label.active_participants": "Participants actifs",
    "moduleTitle.postalAddress": "Titre du module.adresse postale",
    "tasks.return_task": "Tâche révisée",
    "organisation.change_organisation_state": "Modifier le statut de l'organisation",
    "moduleTitle.roles": "Rôles",
    "label.no_config_key_available": "Aucune configuration n'est possible pour cette section",
    "placeholder.selectLanguage": "Sélectionner la langue",
    "states.office_signoff": "Validation par le bureau",
    "notifications.translations_has_been_updated.failure": "La mise à jour de la traduction a échoué",
    "logs.minute": "minute",
    "label.last_activity": "Dernière activité",
    "sidebar.user_guide": "Guide d'utilisateur",
    "label.trained_award_leader": "un chef de groupe formé",
    "table.progress": "Progrès",
    "table.suboperating_authorities": "Sous-entité d'opération",
    "activity.cannot_edit_activity_offline": "Vous ne pouvez pas modifier une activité, un voyage d'aventure ou un projet Or si vous êtes hors ligne.",
    "label.user_does_not_have_permissions": "L'utilisateur n'a pas l'autorisation de voir ce contenu.",
    "notifications.assessor_has_been_approved": "L'évaluateur a été approuvé",
    "route.activity_approval": "Approbation des activités",
    "moduleTitle.role": "Rôle",
    "button.run": "Débuter",
    "label.to": "À",
    "notifications.file_has_been_updated": "Le fichier a été mis à jour",
    "moduleTitle.edit_coordinator": "Modifier le coordonnateur",
    "notifications.authorization_code_is_no_longer_valid": "Le code d’autorisation est expiré.",
    "button.reject": "Rejeter",
    "label.label.participant_status": "Status du participant",
    "award.gold_level": "Prix Or",
    "sidebar.variables": "Variables",
    "parentalConsent.checkbox_copy": "Je confirme que je suis le parent ou tuteur légal de {firstName} {lastName}. Je consens à sa participation au programme le Prix international du Duc d’Édimbourg, au sein de {organisationName} et sous la supervision de son chef de groupe. Je reconnais avoir lu, compris et accepté les exigences et conditions de participation énoncées ci-dessus et sur le site Web de l’entité responsable de l’administration du Prix.",
    "button.go_to_dashboard": "Aller au tableau de bord",
    "button.add_option": "Ajouter une option",
    "label.is_completed": "est complet",
    "pageTitle.award_units": "Centres du Prix",
    "states.completed": "Complété",
    "button.adventurous_journey_template_settings": "Réglages des modèles de voyage d'aventure",
    "label.system_rights": "Droits du système",
    "label.assessor_assesstment_award_start_date": "Date de l'évaluation du Prix",
    "label.update_translation_question": "Les traductions de toutes les langues existantes pour les projets sélectionnés seront mises à jour.",
    "button.login": "Se connecter",
    "label.name_of_the_unit": "Nom du groupe",
    "button.send": "Envoyer",
    "award.ajs": "Voyage d'aventure",
    "meta.payments_expired": "Paiements - Expériés",
    "label.age": "Âge",
    "notifications.payment_info_updated": "Vos informations de paiement ont été mis à jour",
    "table.is_completed": "est complet",
    "table.invited_by": "Invité par",
    "route.files": "Fichiers",
    "route.assessors": "Évaluateurs",
    "info.aj_supervisor_is_mandatory": "Pour le voyage préparatoire, le superviseur recevra la demande d'évaluation et pour le voyage de qualification, l'évaluateur recevra la demande d'évaluation.",
    "pageTitle.my_participants": "Mes participants",
    "label.change_leader_status": "Modifier le statut de l'évaluateur",
    "moduleTitle.parent_consent_form": "Formulaire du consentement des parents / tuteurs",
    "notifications.authorization_contact_has_been_set": "Le contact autorisé a été défini",
    "button.close": "Fermer",
    "label.independent_country": "Pays indépendant",
    "notifications.aj_preparation_training_has_been_returned": "L'entraînement préparatoire a été révisé",
    "route.history_log": "Historique",
    "participant.account_settings": "Réglages du compte",
    "label.bulk_action_error_item": "{globalId} {firstName} {lastName} {email} car ",
    "label.orb_account": "Compte CVP",
    "notifications.file_url_is_not_specified_in_configuration": "L'URL du fichier n'est pas indiqué dans la configuration",
    "notifications.award_unit_has_been_removed": "Le centre du Prix a été supprimé",
    "table.parent": "Parent",
    "label.mode_of_transport": "Moyen de transport",
    "label.parental_consent_email_info": "N'oubliez pas de vérifier le courriel de vos parents et de soumettre le consentement à part des détails du Prix",
    "label.current_award": "Niveau en cours",
    "table.action": "Action",
    "pageTitle.suboperating_authorities": "Sous-entité d'opération",
    "notifications.award_leader_has_been_assigned": "Un chef de groupe a été attribué.",
    "tabs.sign_offs_locally": "Approbations locales",
    "Activity log has been restored": "notification.log_has_been_restored",
    "sidebar.naos": "Entité nationale du Prix",
    "tabs.aj_templates": "Modèle voyage d'aventure",
    "notifications.logging_out": "Déconnexion en cours",
    "label.update_label": "Étiquette actualisée",
    "button.organisation_settings": "Réglages de l'organisation",
    "tabs.independent_award_centers": "Centre public du Prix",
    "label.current": "Actuel",
    "table.location": "Endroit",
    "button.search": "Rechercher",
    "notifications.aj_preparation_training_has_been_approved": "L'entraînement préparatoire a été approuvé.",
    "route.participants": "Participants",
    "label.other_location_information": "Autres renseignements sur l’emplacement",
    "label.number_of_records": "Nombre d'enregistrements",
    "translationsManagement.infoLabel": "Cette fonctionnalité vous permet de mettre à jour les traductions à partir du logiciel POEditor",
    "parentalConsent.i_consent_to_pay_all": "5. Je consens à payer les frais des services de médecins, d’infirmières et d’hospitalisation engagés pour le compte du participant à la suite de quelque accident, blessure, maladie ou perte subis par le participant dans le cadre de toute activité liée au Prix ou de tout déplacement pour se rendre à une telle activité ou en revenir.",
    "label.nationality": "Nationalité",
    "states.approval": "Approbation",
    "notifications.something_went_wrong": "Un problème est survenu.",
    "aj.practice": "Pratique",
    "label.addressLine2": "Adresse ligne 2",
    "label.please_leave_a_note": "Veuillez laisser un commentaire",
    "placeholder.select": "Sélectionner",
    "label.observations": "Observations",
    "label.aim": "Objectif",
    "label.addressLine1": "Adresse ligne 1",
    "roles.aj_instructor": "Instructeur de voyage d'aventure",
    "meta.payments_waiting": "Paiements - En attente",
    "label.award_to_delete": "Niveau du Prix à supprimer",
    "label.category": "Catégorie",
    "roles.instructor": "Instructeur",
    "moduleTitle.remove_customization_and_reset": "Supprimer la personnalisation et réinitialiser la configuration",
    "notifications.participant_registration_has_been_restored": "L'adhésion du participant a été restauré.",
    "organisation.change_award_unit_mode": "Modifier le mode de l'organisation",
    "table.organization_type": "Type d'organisation",
    "notifications.participant_has_been_deleted": "Le participant a été supprimé",
    "label.language_settings": "Réglages de la langue",
    "notifications.event_has_been_approved": "Votre évènement a été approuvé",
    "label.password": "Mot de passe",
    "label.text": "Texte",
    "table.observations": "Observations",
    "notifications.participant_has_been_created": "Le participant a été créé",
    "table.note_for_al": "Commentaires pour le chef de groupe",
    "label.payment_confirmed": "Paiement confirmé",
    "label.previous_completed_award_level": "Niveau précédant (livret)",
    "pageTitle.new_aj_event": "Nouvel évènement du voyage d'aventure",
    "label.backend": "Backend",
    "label.relationship_to_participant": "Lien avec le participant",
    "award.physical_recreation": "Condition physique",
    "contact.collect_emails": "Recueillir des adresses électroniques pour l'envoi de courriel",
    "moduleTitle.assessor_report_reject": "Rejet de l'évaluateur",
    "label.supervisor_report": "Rapport du superviseur",
    "table.role": "Rôle",
    "route.user_guide_web_nao": "Guide d'utilisateur Web - Entité nationale",
    "label.page_not_found": "404 — Page introuvable",
    "table.labels": "Étiquettes",
    "notifications.file_has_been_uploaded": "Le fichier a été téléversé",
    "moduleTitle.address": "Adresse",
    "moduleTitle.lead_coordinator": "Coordonnateur principal",
    "pageTitle.login": "Connexion",
    "label.frontoffice": "Frontoffice",
    "participant.would_you_like_to_remove_registration": "Voulez-vous supprimer cette inscription ?",
    "notifications.rp_has_been_setup": "Le projet Or a été crée",
    "moduleTitle.award_unit": "Centre du Prix",
    "button.remove_file": "Supprimer le fichier",
    "moduleTitle.billing_address": "Adresse de facturation",
    "pageTitle.my_aj_events": "Mes évènements du voyage d'aventure",
    "route.tasks": "Tâches",
    "button.confirm": "Confirmer",
    "label.national_award_authority": "Entité national du Prix",
    "label.independent_award_centre": "Centre public du Prix",
    "award.generate_award_report": "Générer le rapport",
    "route.my_region_office_customization": "Mon bureau régional - Personnalisations",
    "label.email_help_aj_category": "Catégorie du voyage d'aventure.",
    "label.your_report_has_been_rejected": "Vous avez rejeté l'évaluation",
    "notifications.password_change_request_has_been_sent": "Demande de modification de mot de passe envoyée",
    "tabs.detail": "Détail",
    "participant.change_participant_status": "Modifier le statut du participant",
    "table.key": "Touche",
    "label.find_address": "Trouver une adresse",
    "notifications.assessor_has_been_rejected": "L'évaluateur a été révisé",
    "label.transfer_participants": "Transférer des participants",
    "button.continue_to_payment_gateway": "Continuer vers la passerelle de paiement",
    "notifications.participant_registration_has_been_removed": "L'adhésion du participant a été supprimé",
    "moduleTitle.page_not_found": "404 — Page introuvable",
    "route.adventurous_journeys": "Voyage d'aventure",
    "states.registration_assessment": "Évaluation de l’inscription",
    "heading.change_award_unit_mode": "Modifier le mode du centre du Prix",
    "label.user_guide_web_nao": "Guide de l'utilisateur Web- Entité nationale",
    "tabs.silver_level": "Prix Argent",
    "table.paid_by": "Payé par",
    "label.your_report_has_been_successfully_sent": "Votre rapport a été soumis avec succès",
    "sidebar.my_organization": "Mon organisation",
    "pageTitle.participants": "Participant",
    "notifications.preparation_training_has_been_updated": "L'entraînement préparatoire a été mis à jour",
    "moduleTitle.server_is_unreachable": "Impossible de joindre le serveur",
    "label.last_activity_date": "Date de la dernière activité",
    "award.bronze_level": "Prix Bronze",
    "moduleTitle.award_units": "Centres du Prix",
    "table.completed": "Complété",
    "moduleTitle.revise_message": "Message révisé",
    "table.lastUsed": "Dernière utilisation",
    "award.bronze_to_gold_level": "Prix Bronze à Or",
    "button.change_password": "Modifier le mot de passe",
    "label.nao_price": "Coût de l'entité nationale du Prix",
    "label.payment_state": "Statut du paiement",
    "label.wwc_expired": "expiration du WWC",
    "label.award_office_signoff_date": "Date d'approbation par le bureau du Prix",
    "label.award_unit": "Centre du Prix",
    "award.gold_level_short": "Or",
    "moduleTitle.other_info": "Autres informations",
    "table.note": "Note",
    "label.search_by_email_first_or_last": "Recherche par courriel, par prénom ou par nom de famille",
    "tabs.history": "Historique",
    "notifications.label_has_been_created": "L'étiquette a été créé",
    "tabs.unassigned_participants": "Participants sans chef de groupe",
    "table.main_award_leader": "Chef de groupe principal",
    "parentalConsent.i_as_the_parent": "3. En tant que parent ou tuteur légal, j’assume tous les risques liés aux activités du Prix.",
    "label.state": "État",
    "notifications.award_leader_has_been_removed": "Le chef de groupe a été supprimé",
    "tabs.organization_detail": "Informations sur l'organisation",
    "table.operating_authorities": "Entité d'opération",
    "label.available_labels": "Étiquettes disponibles",
    "modal.select": "Sélectionner",
    "tabs.expired_payments": "Paiements expirés",
    "moduleTitle.note_for_al": "Commentaires pour le chef de groupe",
    "moduleTitle.confirm": "Confirmer",
    "notification.new_activity_added": "Une nouvelle activité a été ajoutée",
    "notifications.award_leader_has_been_moved": "Le chef de groupe a été déplacé",
    "label.award_mode": "Mode du Prix",
    "label.phone": "Téléphone",
    "notifications.organization_has_been_updated": "Votre organisation a été mis à jour",
    "moduleTitle.assessor": "Évaluateur",
    "label.bulk_action_confirmation": "Confirmation de l'action de masse",
    "table.parent_approval": "Consentement des parents",
    "label.date_of_delivery": "Date de livraison",
    "sidebar.assessors": "Évaluateurs",
    "label.journey_activity": "Activité du voyage",
    "award.inactive_award": "Prix inactif",
    "label.end_date": "Date de fin",
    "label.orb_testing": "Test CVP",
    "label.no_activities": "Aucunes activités",
    "moduleTitle.please_confirm": "Veuillez confirmer",
    "button.login_with_another_account": "Se connecter avec un autre compte",
    "tasks.reject_registration": "Adhésion rejetée",
    "label.submitted_after_date": "Soumis par la suite",
    "label.update_translations_successful": "{count} éléments modifiés avec succès.",
    "button.assign_leader": "Attribuer un chef de groupe",
    "table.already_running": "En cours",
    "label.no": "Non",
    "label.count_items_selected": "{count} items sélectionnés",
    "label.secondary_phone_number": "Numéro de téléphone secondaire",
    "label.my_experience": "Mon expérience",
    "notifications.adventurous_journey_has_been_approved": "Votre voyage d'aventure a été approuvé",
    "pageTitle.mro_detail": "Information - Bureau divisionnaire",
    "moduleTitle.nao_specific_info": "Information sur l'entité nationale",
    "label.preparing_document_for_import": "Préparation du document pour l'importation",
    "tasks.observations": "Observations",
    "notifications.confirmation_email_has_been_sent": "Votre courriel de confirmation a été envoyé",
    "button.restore": "Restaurer",
    "label.importing_file": "Importation du fichier",
    "label.or_dont_agree": "Vous n'êtes pas d'accord? Vous pouvez",
    "moduleTitle.award_leader": "Chef de groupe",
    "label.me": "(moi)",
    "tabs.sub_global_operating_partners": "\nPartenaires opérationnels sub-globaux",
    "button.export_table": "Exporter le tableau",
    "organisation.move_award_unit": "Déplacer le centre du Prix",
    "label.file_category": "label.file_category",
    "notifications.connecting_to_server": "Connexion au serveur...",
    "parentalConsent.i_understand_that_a_and_b": "11. Je comprends que, dans le cadre des activités liées au Prix : <br /> a. il est interdit aux participants de conduire un véhicule motorisé ou de transporter d’autres participants à moins que le conducteur possède un permis de conduire valide et une police d’assurance couvrant toute blessure causée par sa conduite; et b. il est interdit aux participants de monter à bord d’un véhicule conduit par une personne qui ne participe pas au Prix, à moins que celle-ci possède un permis de conduire valide et une police d’assurance couvrant toute blessure causée par sa conduite.",
    "table.reason": "Raison",
    "pageTitle.contacts": "Contacts",
    "states.award_leader_approval": "Approbation du chef de groupe",
    "meta.payments": "Paiements",
    "label.suboperating_authority": "Sous-entité d'opération",
    "route.my_region_office": "Mon bureau régional",
    "states.registration_not_approved": "Adhésion rejeté",
    "label.direct_entrant": "Adhésion directe",
    "tabs.all_participants": "Tous les participants",
    "tabs.payment": "Paiement",
    "label.email_help_activity_name": "Nom de l'activité.",
    "title.update_report": "Rapport de mise à jour",
    "label.repeat_new_password": "Entrer à nouveau le mot de passe",
    "label.other_roles": "Profil CVP",
    "logs.hours": "heures",
    "notifications.spreadsheet_has_been_imported_successfully": "Le classeur a été importé avec succès",
    "label.bulk_action_question": "Effectuer la modification des {count} items?",
    "moduleTitle.personal_details": "Informations personnelles",
    "label.bulk_action_emailing": "Courriel d'invitation au participant au niveau suivant",
    "route.my_events": "Mes évènements",
    "button.delete_award": "Supprimer le Prix",
    "errors.include_both_lower_and_upper_case": "Doit contenir au moins une majuscule et une minuscule",
    "tabs.removed_participant_registrations": "Adhésions du participant supprimés",
    "sidebar.mynao": "Mon entité nationale du Prix",
    "tabs.office_details": "Informations sur le groupe",
    "label.major": "Concentration",
    "tabs.documents": "Documents",
    "label.new_password": "Nouveau mot de passe",
    "sidebar.adventure_journey": "Voyage d'aventure",
    "pageTitle.customizations": "Personnalisation",
    "moduleTitle.assessor_report": "{role} rapport",
    "label.registration_date": "Date d'adhésion",
    "notifications.training_has_been_added": "Une formation a été ajoutée.",
    "aj.qualifying": "Qualification",
    "moduleTitle.you_have_been_logged_out_session_terminated": "Vous avez été déconnecté car la session est expirée.",
    "award.service": "Service à la collectivité",
    "notifications.rp_state_has_been_changed": "Le projet Or a été modifié",
    "label.ctest_access": "Accessibilité au site test",
    "table.created": "Créé",
    "tasks.revise_task": "Tâche révisée",
    "button.assign": "Attribuer",
    "button.return": "Retour",
    "table.status": "Status",
    "button.restore_activity": "Restaurer l'activité",
    "tabs.new_aj_event": "Nouvel évènement du voyage d'aventure",
    "roles.if_staff_viewer": "Personnel de la Fondation visionneur",
    "notifications.new_template_has_been_created": "Un nouveau modèle a été créé",
    "global.something_went_wrong": "Un problème est survenu.",
    "table.expire_day": "Date d'expiration",
    "tabs.history_log": "Historique",
    "label.form_of_payment": "Moyen de paiement",
    "button.add_training": "Ajouter une formation",
    "label.par_reg_cust_note": "Cet onglet vous permet de personnaliser les champs qui apparaîtront lors de l'inscription du participant et affecteront les informations que vous collectez. Veuillez contacter votre bureau régional si vous désirez effectuer des changements- Seuls les administrateurs du système ont accès à cette fonction.",
    "label.my_qualification": "Ma qualification",
    "button.add_new_profile_question": "Ajouter une question de profil",
    "table.operating_authority": "Entité responsable du Prix",
    "table.aim": "Objectif",
    "table.awards": "Prix",
    "participant.deactivate_account": "Désactiver le compte",
    "table.organization_name": "Organisation",
    "label.email_help_award_leader_first_name": "Prénom du chef de groupe.",
    "table.date": "Date",
    "tasks.would_you_like_to_delete": "Voulez-vous supprimer ce participant?",
    "notifications.configuration_value_has_been_updated": "Votre configuration a été mise à jour",
    "ajTemplates.fill_from_template": "Utiliser les données du modèle",
    "contact.send_test_email": "Envoyer un courriel test",
    "moduleTitle.aj_preparation_and_training": "Entraînement préparatoire",
    "label.ce_be": "Emails personnalisables (traductions des emails)",
    "button.notify_participant": "Aviser le participant",
    "label.parent_phone": "Numéro de téléphone des parents / tuteurs",
    "label.nao_regulations": "Règlement du bureau National",
    "award.skills": "Habiletés",
    "label.reject_application": "rejeter l'application",
    "leader.delete_account": "Supprimer le compte",
    "table.assign": "Attribuer",
    "roles.aj_supervisor": "Superviseur voyage d'aventure",
    "label.logout": "Déconnecter",
    "moduleTitle.award_leader_edit": "Modifier le chef de groupe",
    "moduleTitle.training": "Formation",
    "notifications.coordinator_has_been_removed": "Le coordonnateur a été supprimé",
    "tabs.operating_partners": "Partenaires opérationnels",
    "moduleTitle.main_award_leader": "Chef de groupe / coordonnateur principal",
    "label.bulk_action_successful": "{count} items ont été modifiés avec succès",
    "tasks.clear_email_revision": "Effacer la révision des courriels",
    "table.preparation": "Préparation",
    "table.delete": "Supprimer",
    "label.safeguarding_policy": "Politique sur la protection des parties prenantes de la Fondation. du Prix-International.",
    "sidebar.reports": "Rapports",
    "pageTitle.sub_global_operating_partners": "Partenaires opérationnels sous-mondiaux",
    "label.is_major_activity_confirmation": "Le participant a déjà une concentration à un autre niveau du Prix. Voulez-vous en ajouter une?",
    "pageTitle.operating_authorities": "Entité d'opération",
    "label.delete_participant_award_modal_question_detail": "Êtes-vous sûr de vouloir supprimer {awardLevel} pour le participant {participantId}.",
    "label.confirmed": "Confirmé",
    "notifications.invitation_has_been_sent": "L'invitation a été envoyée",
    "pageTitle.independent_countries": "Pays indépendants",
    "label.assessors_email": "Courriel de l'évaluateur",
    "tasks.approve_assessor_registration": "Approuver l'adhésion de l'évaluateur",
    "table.award_duration": "Durée du Prix",
    "notifications.organization_has_been_moved": "L'organisation a été déplacé.",
    "pageTitle.nao_payment": "Paiement - Bureau national",
    "participant.history_log": "Historique",
    "label.rejected_with_note": "Rejeté avec une note:\"{note}\"",
    "label.already_running": "Opère déjà le Prix",
    "button.continue": "Continuer",
    "award.no_data_to_show": "Aucune entrée",
    "participant.send_email_invitation_again_question": "Renvoyer le courriel d’invitation?",
    "label.reason_for_changing_assessor": "Raison pour le changement d'évaluateur",
    "button.delete": "Supprimer",
    "moduleTitle.requirements_and_conditions": "Exigences et conditions",
    "roles.leader": "Chef de groupe",
    "label.if_download_doesnt": "Si le téléchargement ne démarre pas automatiquement, vérifiez les réglages pour les fenêtres de dialogue",
    "dashboard.your_todo_list": "Chose à faire",
    "notifications.award_unit_has_been_returned": "le centre du Prix a été révisé",
    "moduleTitle.participant_activities": "Activités du participant",
    "errors.qualification_or_experience_required": "Une qualification ou une expérience est requise",
    "label.active_leaders": "Chefs de groupes actifs",
    "aj.preparation": "Préparation",
    "button.change_state": "Modifier l'état",
    "label.current_password": "Mot de passe actuel",
    "pageTitle.global_operating_partners": "Partenaires opérationnels mondiaux",
    "moduleTitle.contact_settings": "Paramètres du contact",
    "button.remove_photo": "Supprimer la photo",
    "notifications.activity_has_been_setup": "Une activité a été crée",
    "errors.must_be_more_than": "Plus de {limit}",
    "table.goal": "Objectif",
    "notifications.coordinator_has_been_set": "Le coordonnateur a été défini",
    "label.cc": "Cc",
    "label.duration": "Durée",
    "table.actions": "Actions",
    "participant.send_email_invitation_again": "Renvoyer le courriel d’invitation?",
    "moduleTitle.would_you_like_to_remove_participant": "Voulez-vous supprimer ce participant #{value}",
    "parentalConsent.i_authorise_employees": "4. J’autorise les employés, les dirigeants et les mandataires du centre du Prix et toute autre personne participant de près ou de loin à l’organisation du Prix à obtenir, en cas d’accident, de blessure, de maladie ou de perte subi par le participant dans le cadre des activités, événements et déplacements en lien avec le Prix, l’aide et les traitements médicaux nécessaires, notamment les services de médecins, d’infirmières et d’hospitalisation.",
    "button.reload_page": "Actualiser la page",
    "moduleTitle.update_translations": "Mise à jour des traductions du projet",
    "label.report_description": "Les champs inclus et les mises à jour récentes ne sont actuellement disponibles qu'en anglais. Nous étudions des solutions pour qu'elles soient disponibles dans d'autres langues.",
    "table.email": "Courriel",
    "label.new_goal": "Nouvel objectif",
    "label.participant_survey_parent": "Je consent à ce que mon enfant, {firstName} {lastName}, aie l'opportunité de participer aux sondages du Prix dans le but de connaître l'expérience des participants, de mesurer les résultats et l'impact du Prix ou toutes autres recherche qui sont en lien avec le but et la stratégie du Prix. Pour plus d'information sur l'étude actuelle, cliquez sur <a href={url}>ici</a>",
    "errors.invalid_email_address": "Courriel non valide",
    "pageTitle.new_contact": "Nouveau contact",
    "sidebar.gops": "POGs",
    "button.manage_participants": "Gérer les participants",
    "errors.invalid_phone_format": "Numéro de téléphone non valide",
    "notifications.login_details_have_been_changed": "Les détails de l'entrée ont été modifiés",
    "moduleTitle.participant_logs": "Entrées du participant",
    "label.save": "Sauvegarder",
    "label.frequently_asked_questions": "Questions fréquemment posées",
    "label.city": "Ville",
    "notifications.configuration_value_has_been_reset": "La configuration a été réinitialisée",
    "states.office_sign_off": "Validation par le bureau",
    "button.save": "Sauvegarder",
    "button.import_data_from_selected_file": "Importer les données à partir du fichier sélectionné",
    "parentalConsent.i_understand_that_the_participant_cannot": "9. Je comprends que le participant ne peut commencer un volet du Prix tant que je n’aurai pas vérifié que la personne qu’il a choisie pour encadrer, superviser ou évaluer bénévolement ce volet (si elle n’est pas employée du centre du Prix) possède l’expérience et les compétences requises pour le faire, et tant que ce bénévole n’aura pas rempli et retourné au centre du Prix les documents requis.",
    "pageTitle.apiKeys": "Clés API",
    "label.international_region": "Région internationale",
    "tabs.levels": "Niveaux",
    "tabs.additional_files": "Fichiers supplémentaires",
    "label.continuation_level": "Adhésion au niveau suivant",
    "table.adventurous_journey_detail": "Détail du Voyage d'aventure",
    "button.set": "Définir",
    "label.i_certify_that_as_the_assessor": "En tant que {role} de cette activité, j’atteste que le participant satisfait aux exigences.",
    "table.coordinator": "Coordonnateur",
    "participant.send_confirmation_email_again": "Envoyer le courriel de confirmation à nouveau?",
    "table.report": "Rapport",
    "label.update_translations_results": "Mettre à jour les résultats de traductions",
    "table.observation_note": "Commentaires des observations",
    "label.view_more": "Voir plus",
    "notifications.payment_link_has_been_reset": "Le lien de paiement a été réinitialisé",
    "table.type": "Type",
    "moduleTitle.updateConfigurationKey": "Mise à jour de la clé de configuration",
    "sidebar.independent_award_centers": "Centre public du Prix",
    "table.activity_type": "Type d'activité",
    "label.awardMode.online": "En ligne",
    "table.data_state": "Dernier rafraîchissement des données",
    "button.generate_report": "Générer le rapport",
    "moduleTitle.assessed_by_award_leader": "Évalué par le chef de groupe",
    "table.child_protection_number": "Numéro de la protection de l'enfance",
    "button.bulk_change": "Modifications de masse",
    "label.send_welcome_email": "Envoyer un courriel de bienvenue",
    "label.award_state": "État du Prix",
    "moduleTitle.overview": "Sommaire",
    "table.aj_detail": "Détails du voyage d'aventure",
    "pageTitle.tasks_activity_approvals": "Approbation de l'activité",
    "label.section": "Volet",
    "route.history": "Historique",
    "route.event_participants": "Évènements des participants",
    "participant.account_detail": "Réglages du compte",
    "route.dashboard": "Tableau de bord",
    "table.payments": "Paiements",
    "pageTitle.profile": "Profil",
    "organisation.remove_organisation": "Supprimer l'organisation",
    "pageTitle.my_organization": "Mon organisation",
    "label.award_leader": "Chef de groupe",
    "notifications.assessor_has_been_updated": "L'évaluateur a été mis à jour",
    "label.participant_personal_reflection": "Réflexion personnelle du participant",
    "button.add_key": "ajouter une touche",
    "header.appMotto": "Duc",
    "table.qualifying": "Qualification",
    "button.upload": "Téléverser",
    "button.resend": "Renvoyer",
    "label.filename": "Nom du fichier",
    "label.change_parental_consent": "Modifier le consentement parental",
    "button.cancel": "Annuler",
    "label.aply_to_all_langs": "S'applique à toutes les langues",
    "route.customization": "Personnalisation",
    "errors.minimal_duration_is": "La durée minimale est de 30 min",
    "label.email_help_participant_first_name": "Prénom du participant.",
    "label.participant_status": "Statut du participant",
    "award.bronze_level_short": "Bronze",
    "label.phone_type": "Type de numéro de téléphone",
    "global.night": "nuit",
    "button.adventurous_journey_settings": "Réglages du voyage d'aventure",
    "participant.leader_must_be_selected": "Vous devez sélectionner un chef de groupe",
    "pageTitle.translationsManagement": "Gestion des traductions",
    "moduleTitle.user_added_preparation_and_training": "L'utilisateur a ajouté un entraînement préparatoire",
    "table.approve": "Approuver",
    "label.role_in_organisation": "Rôle dans l'organisation",
    "states.finished": "Terminé",
    "label.created": "Créé",
    "button.back_to_home": "Retourner à la page d'accueil",
    "label.options": "Options",
    "contact.next_level_invitation": "Invitation au prochain niveau.",
    "moduleTitle.activity_detail": "Détails de l'activité",
    "route.section_signoff": "Validation du volet",
    "moduleTitle.assign_labels_bulk": "Attribuer les étiquettes sélectionnées aux participants ${itemCount}.",
    "button.contact_settings": "Paramètres du contact",
    "label.transation_id": "Numéro de la transaction",
    "notifications.activity_has_been_updated": "L'activité a été mise à jour",
    "sidebar.awards": "Prix",
    "parentalConsent.images_consent": "En tant que parent ou tuteur légal du participant, j’autorise la Fondation à utiliser toutes images à des fins promotionnelles.",
    "participant.would_you_like_to_delete": "Voulez-vous supprimer ce compte?",
    "roles.user": "Utilisateur",
    "label.label": "Étiquette",
    "label.select_sheet": "Sélectionnez la feuille de votre ordinateur",
    "global.no_results": "Aucun résultat",
    "moduleTitle.address_line_2": "Ligne d'adresse 2",
    "states.awaiting_office_sign_off": "En attente de la validation par le bureau",
    "moduleTitle.export": "Exporter",
    "moduleTitle.address_line_1": "Ligne d'adresse 1",
    "notifications.participant_has_been_assigned": "Le participant a été rattaché à un chef de groupe. ",
    "roles.viewer": "Visualiseur",
    "label.participants_total": "Nombre total de participant",
    "errors.auth_code_is_no_longer_valid": "Le code d'autorisation n'est plus valide - il a peut-être été utilisé ou il est expiré",
    "label.file_is_not_available": "Fichiers non disponible",
    "button.select_template": "Choisir un modèle",
    "label.payment": "Paiement",
    "award.silver_level_short": "Argent",
    "table.participant_id": "Numéro du participant",
    "text.hours_old": "vieux de {hours} heures",
    "moduleTitle.your_personal_information": "Vos informations personnelles",
    "aj.minimum_date_recommendation": "Durée minimale recommandé pour le voyage préparatoire et {name} est",
    "label.date_of_payment": "Date du paiement",
    "button.view": "Voir",
    "label.create_new_label": "Création de nouvelle étiquette",
    "title.confirmation": "Confirmer",
    "button.set_participants": "Définir les participants",
    "roles.assessor": "Évaluateur",
    "moduleTitle.coordinator_settings": "Configuration du coordonnateur",
    "label.parent_relationship": "Lien",
    "table.nao": "Entité nationale",
    "notifications.email_has_been_sent": "Le courriel a été envoyé",
    "label.email_help_participant_full_name": "Nom complet du participant.",
    "sidebar.suboperating_authorities": "Sous-entité d'opération",
    "route.award": "Prix",
    "label.no_roles": "Aucun rôle",
    "table.files": "Fichiers",
    "aj.minimum_date_requirements": "Le nombre de jour minimal pour le voyage de qualification est",
    "pageTitle.labels": "Étiquettes",
    "label.participant_is_semi_offline": "Le participant est hors ligne",
    "moduleTitle.other_coordinators": "Autres coordonnateurs",
    "button.updateSelectedLanguage": "Sélectionner la langue",
    "tasks.approve_award_registration": "Adhésion approuvée",
    "participant.invite_participant_to_next_level": "Inviter le participant au prochain niveau?",
    "label.twitter": "Twitter",
    "pageTitle.awards": "Prix",
    "warning.award_marked_as_paid": "Attention : Il y a au moins un niveau du Prix ou une inscription marquée comme payée.  Veuillez consulter les directives de paiement et de remboursement avant de confirmer.",
    "table.edit": "Modifier",
    "states.change_to_state_warning_missing_hours_to_complete": "AVERTISSEMENT : Le nombre d'heures minimales n'a pas été entré. Voulez-vous continuer?",
    "label.dofe": "Prix international",
    "moduleTitle.after_assigning_a_role_to_yourself": "Après vous avoir modifié ou ajouté un rôle, vous devrez vous reconnecter.",
    "label.transaction_id": "Numéro de la transaction",
    "table.suboperating_authority": "Sous-entité responsable du Prix",
    "label.participant_survey": "Je suis heureux de participer au sondage sur la satisfaction du participant.",
    "label.created_by": "Créé par",
    "button.send_confirmation_email_again_question": "Renvoyer le courriel de confirmation.",
    "label.email_help_award_leader_email": "Courriel du chef de groupe.",
    "label.name": "Nom",
    "tabs.gold_level": "Prix Or",
    "pageTitle.award_documents": "Documents du Prix",
    "label.online_payments": "Paiement en ligne",
    "label.child_protection_number": "Numéro de la protection de l'enfance",
    "participant.send_password_recovery_email": "Envoyer le courriel de récupération de mot de passe?",
    "notifications.new_log_has_been_added": "Une nouvelle entrée a été ajoutée",
    "moduleTitle.add_gop_role": "Ajouter un rôle POG ou Sub-POG",
    "label.organization_name": "Nom de l'organisation",
    "pageTitle.my_organization_templates": "Mon organisation - Modèles",
    "pageTitle.award_leaders": "Chefs de groupe",
    "label.status": "Status",
    "label.street": "rue",
    "roles.if_staff_superuser": "Personnel de la Fondation utilisateur suprême",
    "table.licence_holder": "Détenteur de licence",
    "label.created_at": "Créé à",
    "table.section": "Volet",
    "table.system_rights": "Droits du systèmes",
    "label.iac_type": "Type de centre public du Prix",
    "label.other": "Autre",
    "moduleTitle.login": "Connexion",
    "label.no_data_to_show": "aucune donnée",
    "aj.cannot_modify_award_level_if_participants_are_assigned": "Vous ne pouvez pas modifier le niveau du Prix si les participants sont attribués",
    "tabs.waiting_payments": "Paiements en attente",
    "global.supervisor": "Superviseur",
    "notifications.new_role_has_been_added": "Votre nouveau rôle a été ajouté",
    "award.silver_level": "Prix Argent",
    "heading.change_awards_mode": "Modifier le mode du Prix",
    "button.save_changes": "enregistrer les modifications",
    "organisation.would_you_like_to_move_award_unit": "Où voulez-vous supprimer cette organisation?",
    "label.fields": "\nchamps.d'étiquette",
    "label.email_help_organization_name": "Nom du centre du Prix",
    "pageTitle.mro_related_detail": "Informations - Bureau divisionnaire ",
    "table.started_at": "Commencé au",
    "parentalConsent.i_consent_to_the_award_unit": "2. J’accepte que le centre du Prix et toute autre personne participant de près ou de loin à l’organisation du programme, y compris les bénévoles* et les conducteurs rémunérés, transportent au besoin les participants dans le cadre des activités et événements en lien avec le Prix. Je comprends que le centre du Prix m’informera d’avance de la date, de l’heure et de l’itinéraire d’un tel déplacement. ",
    "logs.minutes": "minutes",
    "label.total_participants": "Nombre de participants",
    "moduleTitle.contact_info": "Information du contact",
    "table.payment_link": "Lien de paiement",
    "errors.please_contact_your_local_award_staff": "Veuillez contacter le personnel du Prix"
}